import AddIcon from "@mui/icons-material/Add";
import BackspaceIcon from "@mui/icons-material/Backspace";
import {Link, Typography} from "@mui/material";
import * as nouvelleSouscriptionFormNames from "../others/nouvelleSouscriptionFormNames";
import DialogInformation from "../../../../common/components/general/DialogInformation";


import {PuiCheckbox, PuiDefaultPage, PuiFormikForm, PuiGrid,} from "@portnet/ui";
import {Formik} from "formik";
import React, {useCallback, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {generatePath, useNavigate, useParams} from "react-router-dom";
import AppSelect from "../../../../common/components/inputs/AppSelect";
import AppSpecificReferentielField from "../../../../common/components/inputs/AppSpecificReferentielField";
import AppTextField from "../../../../common/components/inputs/AppTextField";
import AppButton from "../../../../common/components/ui/AppButton";
import AppSection from "../../../../common/components/ui/AppSection";
import {
  CONFIRMATION_MSG_SOUSCRIPTION_AVEC_Forfait,
  EXERCICE_ENCOURS,
  EXERCICE_PROCHAIN,
} from "../../../../common/constants/generalConstants";
import {
  CONSULTATION_PACKAGES_PAGE_ROUTE,
  DETAIL_SOUSCRIPTION_PAGE_ROUTE,
} from "../../../../common/constants/routerConstants";
import useLocalReferentiel from "../../../../common/hooks/useLocalReferentiel";
import * as localReferentielKeys from "../../../../common/localReferentiel/others/localReferentielKeys";
import {nouvelleSouscriptionInitialValues} from "../others/nouvelleSouscriptionInitialValues";
import {nouvelleSouscriptionValidationSchema} from "../others/nouvelleSouscriptionValidationSchemas";
import {
  creationNouvelleSouscriptionAction,
  creationNouvelleSouscriptionReinitializationAction,
  existForfaitAvecMemeExerciceAction,
  getPackageForSouscriptionAction,
} from "../state/nouvelleSouscriptionActions";
import AppSimplePopupReferentielField from "../../../../common/components/inputs/AppSimplePopupReferentielField";
import DialogImportant from "../../../../common/components/general/DialogImportant";
import AppSimpleReferentielField from "../../../../common/components/inputs/AppSimpleReferentielField";


const NouvelleSouscriptionPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { packageId } = useParams();
  const [open, setOpen] = React.useState(false);


  const [textInformation, setTextInformation] = React.useState(false);
  const [user, setUser] = React.useState(null);

  const formRef = React.useRef();
  const [exercicesOptions] = useLocalReferentiel([
    localReferentielKeys.EXERCICE_SOUSCRIPTION_LOCAL_REFERENTIEL_KEY,
  ]);
  const [exerciceSelected, setExerciceSelected] = React.useState();
  const {
    content: detailPackage,
    isLoading: isPackageLoading,
    isSuccessed: isPackageSuccessed,
  } = useSelector((state) => state.souscription.nouvelleSouscription.package);
  const {
    content: idSouscription,
    isLoading: isCreationSouscriptionLoading,
    isSuccessed: isCreationSouscriptionSuccessed,
    error: isCreationSouscriptionFailed,
  } = useSelector(
    (state) =>
      state.souscription.nouvelleSouscription.creationNouvelleSouscription
  );
  const {
    existForfaitAvecMemeExercice: existForfait,
    isLoading: existForfaitAvecMemeExerciceLoading,
    isSuccessed: existForfaitAvecMemeExerciceSuccessed,
    error: existForfaitAvecMemeExerciceFailed,
  } = useSelector(
    (state) =>
      state.souscription.nouvelleSouscription.existForfaitAvecMemeExercice
  );
  const connectedUser = useSelector((state) => state.auth.login.user);
  const [operateurInput, setOperateurInput] = React.useState(<></>);
  const [openConfirmationWindow, setOpenConfirmationWindow] =
    React.useState(false);
  const [ifForfaitExist, setIfForfaitExit] = React.useState(false);
  const [valueForm, setValueForm] = React.useState(null);

  React.useEffect(() => {
    if (
      existForfaitAvecMemeExerciceSuccessed &&
      !connectedUser.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF")
    ) {
      setIfForfaitExit(existForfait.hasForfait);
    }
  }, [existForfaitAvecMemeExerciceSuccessed]);

  const submitHandler = (values) => {
    if (ifForfaitExist) {
      setOpenConfirmationWindow(true);
      setValueForm(values);
    } else {
      confirmerCreationSouscription(values);
      setValueForm(values);
    }
  };
  const [confirmResponse, setConfirmResponse] = React.useState(false);
  const confirmerCreationSouscription = useCallback(
    (values) => {
      if (user === null) {
        dispatch(creationNouvelleSouscriptionAction({ values, packageId }));
      } else {
        dispatch(
          creationNouvelleSouscriptionAction({ values, packageId, user })
        );
      }
    },
    [user, packageId, valueForm, confirmResponse]
  );
  console.log(confirmResponse);
  useEffect(() => {
    if (confirmResponse == true) {
      confirmerCreationSouscription(valueForm);
      setOpenConfirmationWindow(false);
      setConfirmResponse(false);
    }
  }, [confirmResponse]);
  const NavigationActions = ({ formRef }) => {
    return (
      <PuiGrid container>
        <PuiGrid item>
          <AppButton
            color="tertiary"
            startIcon={<BackspaceIcon />}
            onClick={() => {
              formRef.current.resetForm();
            }}
          >
            Effacer
          </AppButton>
        </PuiGrid>
        <PuiGrid item>
          <AppButton
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => {
              formRef.current.submitForm();
            }}
            loading={isCreationSouscriptionLoading}
          >
            Créer
          </AppButton>
        </PuiGrid>
      </PuiGrid>
    );
  };
  const Links = () => {
    return (
      <Typography component="span">
        Accepter les conditions générales et spécifiques d abonnement au
        services de Portnet:
        <Link
          href="/files/PORTNET_NV_Contrat_AM_VF.pdf"
          to="/files/PORTNET_NV_Contrat_AM_VF.pdf"
          target="_blank"
          download
          marginLeft={1}
        >
          Clauses du contrat
        </Link>
      </Typography>
    );
  };

  React.useEffect(() => {
    if (isPackageSuccessed) {
      let inputRender;
      if (detailPackage?.roleOperateur?.description === "Importateur") {
        inputRender = (
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppSpecificReferentielField
              title="Recherche d'importateurs/exportateurs"
              searchKey="OPERATEURS_IMP_EXP"
              label="Importateur"
              getRenderedValue={(row) => row.description}
              getReturnedValue={(row) => row.id}
              formik={false}
              onChange={(e) => setUser(e)}
            />
          </PuiGrid>
        );
      } else if (detailPackage?.roleOperateur?.description === "Banque") {
        inputRender = (
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppSimplePopupReferentielField
              title="Recherche de banques"
              searchKey="LISTE_BANQUES"
              descriptionLabel="Banque"
              label="Banque"
              getRenderedValue={(row) => row.description}
              getReturnedValue={(row) => row.id}
              formik={false}
              onChange={(e) => setUser(e)}
            />
          </PuiGrid>
        );
      } else if (detailPackage?.roleOperateur?.description === "Transitaire") {
        inputRender = (
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppSpecificReferentielField
              title="Recherche de transitaires"
              searchKey="TRANSITAIRES"
              label="Transitaire"
              getRenderedValue={(row) => row.description}
              getReturnedValue={(row) => row.id}
              formik={false}
              onChange={(e) => setUser(e)}
            />
          </PuiGrid>
        );
      } else if (detailPackage?.roleOperateur?.description === "Operateur") {
        inputRender = (
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppSpecificReferentielField
              title="Recherche d'opérateurs"
              searchKey="OPERATEURS_MANUTENTION"
              label="Opérateur"
              getRenderedValue={(row) => row.description}
              getReturnedValue={(row) => row.id}
              formik={false}
              onChange={(e) => setUser(e)}
            />
          </PuiGrid>
        );
      } else if (
        detailPackage?.roleOperateur?.description === "Consignataire"
      ) {
        inputRender = (
          <PuiGrid item xs={12} sm={4} md={4}>
            <AppSimplePopupReferentielField
              title="Recherche de consignataires"
              searchKey="LISTE_CONSIGNATAIRES"
              label="Consignataire"
              getRenderedValue={(row) => row.description}
              getReturnedValue={(row) => row.id}
              formik={false}
              onChange={(e) => setUser(e)}
            />
          </PuiGrid>
        );
      }
      else if (
          detailPackage?.roleOperateur?.description === "ANP"
      ) {
        inputRender = (
            <PuiGrid item xs={12} sm={4} md={4}>
              <AppSimplePopupReferentielField
                  title="Recherche de ports"
                  searchKey="LISTE_PORTS"
                  label="Port"
                  formik={false}
                  descriptionLabel="Nom"
                  getRenderedValue={(row) => row.description}
                  getReturnedValue={(row) => row.id}
                  onChange={(e) => setUser(e)}

              />
            </PuiGrid>
        );
      }
      else {
        inputRender = (
          <PuiGrid>
            Unknown role: {detailPackage?.roleOperateur?.description}
          </PuiGrid>
        );
      }
      setOperateurInput(inputRender);
    }
  }, [isPackageSuccessed]);

  React.useEffect(() => {
    var oneYearFromNow = new Date();
    if (exerciceSelected === EXERCICE_PROCHAIN) {
      setOpen(true);
      oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
      setTextInformation(
        <>
          <strong>{"Important : "}</strong>
          {" Le forfait choisi prendra effet à partir du "}
          <strong>01 Janvier {oneYearFromNow.getFullYear()}</strong>
        </>
      );
    }
    if (exerciceSelected === EXERCICE_ENCOURS) {
      setOpen(true);
      setTextInformation(
        <>
          <strong>{"Important : "}</strong>
          {" Le forfait choisi prendra fin le "}
          <strong>31 Décembre {oneYearFromNow.getFullYear()}</strong>
        </>
      );
    }
  }, [exerciceSelected]);
  console.log(exerciceSelected);

  React.useEffect(() => {
    if (
      exerciceSelected != undefined &&
      !connectedUser.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF")
    ) {
      dispatch(existForfaitAvecMemeExerciceAction(exerciceSelected));
    }
  }, [exerciceSelected]);
  React.useEffect(() => {
    if (isCreationSouscriptionSuccessed) {
      dispatch(creationNouvelleSouscriptionReinitializationAction());
      if (idSouscription) {
        navigate(
          generatePath(DETAIL_SOUSCRIPTION_PAGE_ROUTE, {
            id: idSouscription,
          })
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreationSouscriptionSuccessed, isCreationSouscriptionFailed]);

  React.useEffect(() => {
    dispatch(getPackageForSouscriptionAction(packageId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <PuiDefaultPage
      title="Nouvelle Souscription"
      titleIcon={<AddIcon />}
      trace={["Consultation package", "Souscrire"]}
      navActions={<NavigationActions formRef={formRef} />}
      loading={isPackageLoading || isCreationSouscriptionLoading}
      show={isPackageSuccessed}
      topNav
      bottomNav
      retour
      onRetour={() => navigate(CONSULTATION_PACKAGES_PAGE_ROUTE)}
    >
      {isPackageSuccessed && (
        <Formik
          initialValues={nouvelleSouscriptionInitialValues}
          validationSchema={nouvelleSouscriptionValidationSchema(
            connectedUser.roles
          )}
          onSubmit={submitHandler}
          innerRef={formRef}
          enableReinitalization
        >
          <PuiFormikForm>
            <AppSection title="Création d'une nouvelle souscription">
              <PuiGrid container>
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    label="Code package"
                    value={detailPackage.code}
                    disabled
                    formik={false}
                  />
                </PuiGrid>
                {connectedUser.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") &&(
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    label="Rôle de l'opérateur"
                    value={detailPackage.roleOperateur.description}
                    disabled
                    formik={false}
                  />
                </PuiGrid>)}
                {connectedUser.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") &&
                  operateurInput}
                {!connectedUser.roles.includes(
                  "ROLE_VUPORTUARIA_ADMIN_TARIF"
                ) && (
                  <PuiGrid item xs={12} sm={4} md={4}>
                    <AppTextField
                      label="Société"
                      value={connectedUser.description}
                      disabled
                      formik={false}
                    />
                  </PuiGrid>
                )}
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    label="Type de paiement"
                    value={detailPackage.typePaiment.description}
                    disabled
                    formik={false}
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppSimpleReferentielField
                     searchKey="EXERCICE_SOUSCRIPTION"
                     label="Exercice"
                    name={
                      nouvelleSouscriptionFormNames.NOUVELLE_SOUSCRIPTION_EXERCICE_FORM_NAME
                    }
                    loading={exercicesOptions.isLoading}
                    error={exercicesOptions.hasError}
                    helperText={exercicesOptions.error}
                    getOptionLabel={(option) => option.description}
                    getOptionValue={(option) => option.code}
                    onChange={(value) => setExerciceSelected(value)}
                    required
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    label="Transaction autorisée"
                    value={detailPackage.typeTransactionAutorisee.description}
                    disabled
                    formik={false}
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    label="Frais d'acces annuel(TTC)"
                    value={parseFloat( detailPackage.abonnementBase* 1.2).toFixed(2)}
                    disabled
                    formik={false}
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    label="Validité du package"
                    value={detailPackage.validiteePackage.description}
                    disabled
                    formik={false}
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    label="Début de validité"
                    disabled
                    formik={false}
                    value={detailPackage.debutValidite.description}
                  />
                </PuiGrid>
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    label="Reconduction"
                    value={detailPackage.reconduction ? "Oui" : "Non"}
                    disabled
                    formik={false}
                  />
                </PuiGrid>
                {connectedUser.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") &&(
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    label="Critère de facturation"
                    value={detailPackage.critereFacturation.description}
                    disabled
                    formik={false}
                  />
                </PuiGrid>)}
                {connectedUser?.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") && (
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    label="Paramétre de décompte"
                    value={detailPackage.parametreDecompte.description}
                    disabled
                    formik={false}
                  />
                </PuiGrid>)}
                <PuiGrid item xs={12} sm={4} md={4}>
                  <AppTextField
                    label="Statut du package"
                    value={detailPackage.statut.description}
                    disabled
                    formik={false}
                  />
                </PuiGrid>
                <PuiGrid item xs={12}>
                  <AppTextField
                    label="Description du package"
                    value={detailPackage.description}
                    multiline
                    rows={6}
                    disabled
                    formik={false}
                  />
                </PuiGrid>
              </PuiGrid>
            </AppSection>
            {!connectedUser.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") && (
              <AppSection title="Clauses souscription" sx={{ marginTop: 2 }}>
                <PuiCheckbox name="acceptTerms" label={<Links />} />
              </AppSection>
            )}
          </PuiFormikForm>
        </Formik>
      )}
      {open && (
        <DialogInformation
          open={open}
          close={() => setOpen(false)}
          text={textInformation}
          confirmation={false}
        />
      )}
      {openConfirmationWindow && (
        <DialogImportant
          open={openConfirmationWindow}
          close={() => setOpenConfirmationWindow(false)}
          text={CONFIRMATION_MSG_SOUSCRIPTION_AVEC_Forfait}
          confirmation={true}
          showTitleIcon={true}
          confirmOk={() => {
            setConfirmResponse(true);
          }}
        />
      )}
    </PuiDefaultPage>
  );
};

export default NouvelleSouscriptionPage;
